import type { MaterialNames } from "../material_symbol_names";
import { LitIcon } from "./LitIcon";
interface Props {
  className?: string;
  name: MaterialNames;
  filled?: boolean;
  size?: number;
  weight?: 300 | 400 | 800;
  "aria-hidden"?: boolean;
}
export default function Icon({
  className,
  size = 24,
  name,
  filled = false,
  weight = 400,
  "aria-hidden": ariaHidden
}: Props) {
  const style = {
    fontFamily: "Material Symbols Rounded",
    fontSize: `${size}px`,
    width: `${size}px`,
    height: `${size}px`,
    fontVariationSettings: `'FILL' ${filled ? 1 : 0}`,
    fontWeight: weight
  };

  return (
    <LitIcon style={style} className={className} aria-hidden={ariaHidden} data-testid={`icon-${name}`}>
      {name}
    </LitIcon>
  );
}
